import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tab,
  Nav,
  Dropdown,
  ListGroup,
  InputGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  fetchResult,
  resetData,
  selectId,
  selectLoading,
} from "./resultSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  encryptData,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  decryptData,
  paramsYesNoType,
  handleSetOptionsMaster,
  paramsYesNoType2,
  validateSections,
  showDialogHtml,
  formatDate,
  formatDateTime,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { v4 as uuidv4 } from "uuid"; // Import UUID

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  fetchParam,
  fetchParam2,
  fetchParam3,
  selectDataParam,
  selectDataParam2,
  selectDataParam3,
} from "../param/paramSlice";
import debounce from "lodash/debounce";
import { fetchCustomer } from "../customer/customerSlice";
import SVG from "react-inlinesvg";
import { InputDateRangeForm } from "../../utility/InputDateRangeForm";
import { ImageViewer } from "../../utility/ImageViewer";
import { FaCheck } from "react-icons/fa";

export const ResultIndividual = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);

  const { id } = useParams();

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [desc, setDesc] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [entry, setEntry] = useState("");
  const [mandatory, setMandatory] = useState("");
  const [category, setCategory] = useState("");
  const [cust, setCust] = useState("All");
  const [listCust, setListCust] = useState([]);

  const [optionsCategory, setOptionsCategory] = useState([]);
  const [optionsEntry, setOptionsEntry] = useState([]);
  const [optionsCustomer, setOptionsCustomer] = useState([]);
  const [optionsTextField, setOptionsTextField] = useState([]);

  const paramsId = {
    survey_result_id: id,
  };
  useEffect(() => {
    if (dataId) {
      const initData = dataId?.section.map((item, index) => {
        return {
          ...item,
          section_no: `section-${index + 1}`,
          id: index + 1,
          section_question: item?.section_question.map(
            (question, indexQuestion) => {
              return {
                ...question,
                id: indexQuestion + 1,
              };
            }
          ),
        };
      });

      setSections(initData);
      setActiveKey("section-1");
    }
  }, [dataId]);

  const [sections, setSections] = useState([
    {
      section_id: uuidv4(),
      section_no: "section-1",
      id: 1,
      section_title: "",
      section_desc: "",
      section_question: [
        {
          question_id: uuidv4(),
          id: 1,
          question_desc: "",
          question_type: "",
          question_required: "N",
          question_default_answer: "",
          question_option: [],
          question_rule: [],
        },
      ],
    },
  ]);

  const [activeKey, setActiveKey] = useState("section-1"); // Menyimpan tab yang aktif

  const handleSectionChange = (id, field, value) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, [field]: value } : section
      )
    );
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">Survey Form</CardHeaderTitle>
        </CardHeader>
        <CardBody>
          <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
            <Nav variant="tabs" className="mb-3">
              {sections.map((section) => (
                <Nav.Item key={section.id}>
                  <Nav.Link eventKey={`section-${section.id}`}>
                    Section {section.id}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <Tab.Content>
              {sections.map((section) => (
                <Tab.Pane key={section.id} eventKey={`section-${section.id}`}>
                  {" "}
                  <Form.Group as={Row}>
                    <Form.Label column sm={2}>
                      <b>Section Title</b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        onChange={(e) =>
                          handleSectionChange(
                            section.id,
                            "section_title",
                            e.target.value
                          )
                        }
                        value={section.section_title}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={2}>
                      <b>Description </b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        as="textarea"
                        onChange={(e) =>
                          handleSectionChange(
                            section.id,
                            "section_desc",
                            e.target.value
                          )
                        }
                        value={section.section_desc}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                  <hr />
                  {section.section_question.map((question, indexQuestion) => (
                    <div key={question.id} className="mt-3">
                      <b>Question:</b>

                      <Row>
                        <Col md={6}>
                          <Form.Control
                            as="textarea"
                            placeholder="Add question"
                            value={question.question_desc}
                            disabled
                          />
                        </Col>
                        <Col md={4}></Col>
                        <Col sm="1">
                          <div className="ribbon-label mx-2">
                            <span
                              className={`ribbon-text ${
                                question.question_required === "Y"
                                  ? "required"
                                  : "optional"
                              }`}
                            >
                              {question.question_required === "Y"
                                ? "Required"
                                : "Optional"}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      {["DROPDOWN", "CHECKBOX", "RADIO_BUTTON"].includes(
                        question.question_type
                      ) ? (
                        <div className="mt-3">
                          <b>Options:</b>
                          {(question.question_option || []).map(
                            (option, index) => {
                              // Memisahkan jawaban untuk CHECKBOX menjadi array
                              const selectedAnswers = question.question_answer
                                ? question.question_answer.split(",")
                                : [];
                              const isChecked = selectedAnswers.includes(
                                option.option_id
                              ); // Mengecek apakah opsi dipilih

                              return (
                                <Row
                                  key={index}
                                  className="mb-2 align-items-center"
                                >
                                  <Col md={6}>
                                    <InputGroup>
                                      <input
                                        type="text"
                                        className={`form-control ${
                                          isChecked ? "border-success" : ""
                                        }`} // Menambahkan border hijau jika isChecked true
                                        placeholder="Option"
                                        value={option.option_code}
                                        disabled
                                      />
                                      {isChecked && (
                                        <InputGroup.Text
                                          className={`${
                                            isChecked ? "border-success" : ""
                                          }`}
                                        >
                                          <FaCheck style={{ color: "green" }} />
                                        </InputGroup.Text>
                                      )}
                                    </InputGroup>
                                  </Col>
                                </Row>
                              );
                            }
                          )}
                        </div>
                      ) : question.question_type === "PHOTO" ? (
                        <div className="mt-3">
                          <b>Photo:</b>
                          {/* Here, you can add the logic for handling photo */}
                          <Row>
                            <Col md={6}>
                              {question?.survey_attachments?.map(
                                (item, index) => (
                                  <div
                                    className="small-image"
                                    key={index}
                                    style={{
                                      display: "inline-flex",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <ImageViewer url={item.file_path} />
                                  </div>
                                )
                              )}
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        <div className="mt-3">
                          <Row className="mb-2">
                            <Col md={6}>
                              <InputGroup>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={question?.question_answer}
                                  disabled
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </div>
                      )}

                      <hr />
                    </div>
                  ))}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </CardBody>
      </Card>
    </>
  );
};
